import { render, staticRenderFns } from "./QuestionsWrapper.form.vue?vue&type=template&id=45a25e92&scoped=true&"
import script from "./QuestionsWrapper.form.vue?vue&type=script&lang=js&"
export * from "./QuestionsWrapper.form.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsWrapper.form.vue?vue&type=style&index=0&id=45a25e92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a25e92",
  null
  
)

export default component.exports